<template>
  <div>
    <hshead title page="true" pic="false" BgHeight="4.88rem"></hshead>
    <router-link to class="more-head">
      <div class="left-pic">
        <img src="../assets/images/center/681d8739gy1g3km3fh3pcj218a1n21kx@2x.png" alt />
      </div>
      <div class="center-p">
        <div class="center-name">陈大仙</div>
        <div class="center-tip">一星摄影师</div>
      </div>
      <div class="right-arr">
        <img src="../assets/images/more/r.png" alt />
      </div>
    </router-link>
    <div class="center-profit">
      <div class="profit-ul">
        <div class="profit-li">
          <div class="this-pri">9000.00</div>
          <div class="this-p">总收益</div>
        </div>
        <div class="profit-li">
          <div class="this-pri">8000.00</div>
          <div class="this-p">可提现</div>
        </div>
        <div class="profit-li">
          <div class="this-pri">100.00</div>
          <div class="this-p">待结算</div>
        </div>
      </div>
    </div>
    <div class="more-center">
      <div class="center-ul">
        <router-link to class="center-li">
          <div class="this-img">
            <img src="../assets/images/center/u1.png" style="width:0.51rem"  alt />
          </div>
          <div class="this-p">待分配</div>
        </router-link>
        <router-link to class="center-li">
          <div class="this-img">
            <img src="../assets/images/center/u2.png" style="width:0.82rem"  alt />
          </div>
          <div class="this-p">待审核</div>
        </router-link>
        <router-link to class="center-li">
          <div class="this-img">
            <img src="../assets/images/center/u3.png" style="width:0.74rem"  alt />
          </div>
          <div class="this-p">打回</div>
        </router-link>
        <router-link to class="center-li">
          <div class="this-img">
            <img src="../assets/images/center/u4.png" style="width:0.69rem"  alt />
          </div>
          <div class="this-p">已完成</div>
        </router-link>
        <router-link to class="center-li">
          <div class="this-img">
            <img src="../assets/images/center/u5.png" style="width:0.68rem"  alt />
          </div>
          <div class="this-p">验收不通过</div>
        </router-link>
      </div>
    </div>
    <div class="more-dl">
      <router-link to class="more-li">
        <div class="left-img">
          <img src="../assets/images/center/d1.png" style="width:0.29rem" alt />
        </div>
        <div class="this-p">拍摄行程</div>
        <div class="right-arr">
          <img src="../assets/images/more/r-g.png" alt />
        </div>
      </router-link>
      <router-link to class="more-li">
        <div class="left-img">
          <img src="../assets/images/center/d2.png" style="width:0.39rem" alt />
        </div>
        <div class="this-p">约拍城市</div>
        <div class="right-arr">
          <img src="../assets/images/more/r-g.png" alt />
        </div>
      </router-link>
      <router-link to class="more-li">
        <div class="left-img">
          <img src="../assets/images/center/d3.png" style="width:0.41rem" alt />
        </div>
        <div class="this-p">我的客户</div>
        <div class="right-arr">
          <img src="../assets/images/more/r-g.png" alt />
        </div>
      </router-link>
      <router-link to class="more-li">
        <div class="left-img">
          <img src="../assets/images/center/d4.png" style="width:0.42rem" alt />
        </div>
        <div class="this-p">服务中心</div>
        <div class="right-arr">
          <img src="../assets/images/more/r-g.png" alt />
        </div>
      </router-link>
      <router-link to class="more-li">
        <div class="left-img">
          <img src="../assets/images/center/d5.png" style="width:0.41rem" alt />
        </div>
        <div class="this-p">系统设置</div>
        <div class="right-arr">
          <img src="../assets/images/more/r-g.png" alt />
        </div>
      </router-link>
    </div>
    <router-link to class="center-btn">任务中心</router-link>
  </div>
</template>

<script>
import hshead from "@/components/common/hshead";

export default {
  name: "center",
  data() {
    return {
      active: 4,
      loading: false,
      finished: false
    };
  },
  components: {
    hshead
  }
};
</script>

<style lang="less" scoped>
@import "../assets/less/common.less";
@import "../assets/less/mixin.less";
.more-head {
  margin-top: -3.9rem;
  display: flex;
  padding: 0 0.51rem 0 0.45rem;
  align-items: center;
  height: 1.33rem;
  .left-pic {
    width: 1.33rem;
    height: 1.33rem;
    background-image: linear-gradient(135deg, #66cafa 0%, #4094f7 100%),
      linear-gradient(#ffffff, #ffffff);
    background-blend-mode: normal, normal;
    border-radius: 50%;
    overflow: hidden;
    img {
      width: 1.33rem;
      height: auto;
    }
  }
  .center-p {
    padding-left: 0.3rem;
    flex: 1;
    font-family: PingFang-SC-Medium;
    font-size: 0.34rem;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0rem;
    color: #ffffff;
    .center-tip {
      padding: 0.07rem 0;
      font-family: PingFang-SC-Medium;
      font-size: 0.22rem;
      text-align: center;
      border: 1px solid #ffffff;
      border-radius: 0.18rem;
      width: 1.5rem;
      margin-top: 0.2rem;
    }
  }
  .right-arr {
    width: 0.32rem;
    img {
      width: 0.32rem;
    }
  }
}
.more-center {
  width: 7rem;
  height: 2rem;
  background-color: #ffffff;
  box-shadow: 0rem 0rem 0.24rem 0rem rgba(101, 176, 249, 0.41);
  border-radius: 0.2rem;
  margin-left: 0.25rem;
  margin-top: 0.5rem;
  .center-ul {
    display: flex;
    padding-top: 0.22rem;
    .center-li {
      width: 100/5 * 1%;
      text-align: center;
      display: block;
      .this-img {
        img {
          width: 0.6rem;
          display: inline-block;
        }
      }
      .this-p {
        font-family: PingFang-SC-Medium;
        font-size: 0.26rem;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0rem;
        color: #333333;
      }
    }
  }
}
.center-profit {
    margin-top: 0.47rem;
  .profit-ul {
    display: flex;
    text-align: center;
    .profit-li {
      width: 1/3 * 100%;
      position: relative;
      &::after{
          content: '';
          width: 1px;
        height: 0.49rem;
        background-color: #f4f4f4;
        opacity: 0.5;
        position: absolute;
        right: 0;
        top: 0;
      }
      &:last-child:after{
          width: 0;
      }
      .this-pri {
        font-family: PingFang-SC-Regular;
        font-size: 0.4rem;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0rem;
        color: #ffffff;
      }
      .this-p {
        font-family: PingFang-SC-Medium;
        font-size: 0.24rem;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0rem;
        color: #ffffff;
        opacity: 0.6;
        margin-top: 0.1rem;
      }
    }
  }
}
.more-dl {
  padding: 0.3rem 0.25rem 0 0.4rem;
  .more-li {
    width: 7.5-0.25-0.4rem;
    height: 0.9rem;
    display: flex;
    align-items: center;
    .left-img {
      width: 0.6rem;
      img {
      }
    }
    .this-p {
      font-family: PingFang-SC-Medium;
      font-size: 0.28rem;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0rem;
      color: #666666;
      flex: 1;
    }
    .right-arr {
      width: 0.3rem;
      img {
        width: 0.12rem;
      }
    }
  }
}
.center-btn {
  width: 5.62rem;
  height: 0.8rem;
  line-height: 0.8rem;
  text-align: center;
  background-image: linear-gradient(135deg, #33ccff 0%, #0095ff 100%),
    linear-gradient(#f2f9fb, #f2f9fb);
  background-blend-mode: normal, normal;
  border-radius: 0.4rem;
  font-family: PingFang-SC-Medium;
  font-size: 0.32rem;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0rem;
  color: #ffffff;
  display: block;
  margin: 0.8rem auto 0.7rem auto;
  opacity: 0.8;
  &:active{
      opacity: 1;
       background-image: linear-gradient(135deg, #33ccff 0%, #0095ff 100%),
    linear-gradient(#f2f9fb, #f2f9fb);
  background-blend-mode: normal, normal;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/center.vue